import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Form, Input, Button, Alert } from 'antd';
import { MailOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import authService from '@/services/auth.service';

const ForgotPasswordPage: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [submitted, setSubmitted] = useState(false);

  const onFinish = async (values: { email: string }) => {
    try {
      setLoading(true);
      setError(null);
      await authService.requestPasswordReset(values.email);
      setSubmitted(true);
    } catch (err: unknown) {
      const ax = err as { response?: { data?: { message?: string } }; message?: string };
      setError(ax.response?.data?.message || ax.message || 'Request failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-form-surface">
      {error && (
        <Alert
          className="auth-alert-error"
          message={error}
          type="error"
          closable
          onClose={() => setError(null)}
          showIcon
          role="alert"
          style={{ marginBottom: 16 }}
        />
      )}

      {submitted ? (
        <Alert
          type="success"
          showIcon
          message="Check your email"
          description="If an account with that email exists, a password reset link has been sent. The link expires in 1 hour."
          style={{ marginBottom: 24 }}
        />
      ) : (
        <Form name="forgot-password" layout="vertical" size="large" onFinish={onFinish}>
          <Form.Item
            name="email"
            label="Email"
            rules={[
              { required: true, message: 'Please enter your email' },
              { type: 'email', message: 'Enter a valid email address' },
            ]}
          >
            <Input
              prefix={<MailOutlined aria-hidden />}
              placeholder="name@company.com"
              autoComplete="email"
              inputMode="email"
              autoCapitalize="none"
            />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" block loading={loading} className="auth-submit-button">
              Send reset link
            </Button>
          </Form.Item>
        </Form>
      )}

      <Link to="/login" className="auth-forgot-link" style={{ float: 'none' }}>
        <ArrowLeftOutlined /> Back to sign in
      </Link>
    </div>
  );
};

export default ForgotPasswordPage;
